/**
 * Public inbound composer prompt (`?q=`).
 *
 * SearchAction, Alto, and Dissenter deep-link here. Prefill only — never
 * auto-send. Persist across login the same way `pendingCheckout` does, but
 * never include this value in signup / SSO request bodies.
 */

export const PENDING_PROMPT_KEY = 'pendingPrompt';
export const PENDING_PROMPT_MAX_CHARS = 500;
export const PENDING_PROMPT_MAX_AGE_MS = 2 * 60 * 60 * 1000;

export function firstQueryParam(value) {
  if (Array.isArray(value)) return value[0] || '';
  return typeof value === 'string' ? value : '';
}

export function sanitizePendingPrompt(raw) {
  if (typeof raw !== 'string') return '';
  const text = raw.replace(/\s+/g, ' ').trim();
  if (!text) return '';
  return text.slice(0, PENDING_PROMPT_MAX_CHARS);
}

export function capturePendingPrompt(raw) {
  const text = sanitizePendingPrompt(raw);
  if (!text) return '';
  try {
    if (typeof localStorage === 'undefined') return text;
    localStorage.setItem(PENDING_PROMPT_KEY, JSON.stringify({ text, ts: Date.now() }));
  } catch (_) {
    // Private mode / blocked storage — still return the sanitized text.
  }
  return text;
}

export function readPendingPrompt() {
  try {
    if (typeof localStorage === 'undefined') return '';
    const raw = localStorage.getItem(PENDING_PROMPT_KEY);
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.text !== 'string') return '';
    if (!parsed.ts || Date.now() - parsed.ts > PENDING_PROMPT_MAX_AGE_MS) {
      localStorage.removeItem(PENDING_PROMPT_KEY);
      return '';
    }
    return sanitizePendingPrompt(parsed.text);
  } catch (_) {
    return '';
  }
}

export function clearPendingPrompt() {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.removeItem(PENDING_PROMPT_KEY);
  } catch (_) {
    // ignore
  }
}
